import React, { useState } from 'react';
import { Box, TextField, Button, Typography, Alert, Paper, CircularProgress } from '@mui/material';
import axios from 'axios';
import baseURL from '../../../baseURL';

const formatDate = (d) => {
  if (!d) return '';
  const x = new Date(d);
  return `${String(x.getDate()).padStart(2, '0')}/${String(x.getMonth() + 1).padStart(2, '0')}/${x.getFullYear()}`;
};

const SaleIntimationLetterTab = () => {
  const [catalogueNo, setCatalogueNo] = useState('');
  const [letterDate, setLetterDate] = useState(new Date().toISOString().slice(0, 10));
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const fetchLetter = () => {
    if (!catalogueNo.trim() || !letterDate) {
      setError('Catalogue No and Letter date are required');
      return;
    }
    setError('');
    setLoading(true);
    const token = localStorage.getItem('token');
    axios.get(`${baseURL}/auction/sale-intimation-letter`, {
      params: { catalogueNo: catalogueNo.trim(), letterDate },
      headers: { Authorization: `Bearer ${token}` }
    })
      .then((res) => setData(res.data.data))
      .catch((err) => {
        setError(err.response?.data?.message || err.message);
        setData(null);
      })
      .finally(() => setLoading(false));
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>Sale Intimation Letter</Typography>
      <Typography variant="body2" color="text.secondary" gutterBottom>Letter date must be on or after the auction date.</Typography>
      {error && <Alert severity="error" onClose={() => setError('')} sx={{ mb: 2 }}>{error}</Alert>}
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mb: 2 }}>
        <TextField label="Catalogue No" value={catalogueNo} onChange={(e) => setCatalogueNo(e.target.value)} size="small" placeholder="e.g. 1/2026" />
        <TextField label="Letter Date" type="date" value={letterDate} onChange={(e) => setLetterDate(e.target.value)} InputLabelProps={{ shrink: true }} size="small" />
        <Button variant="contained" onClick={fetchLetter} disabled={loading}>{loading ? <CircularProgress size={24} /> : 'Generate'}</Button>
      </Box>
      {data && (
        <Paper sx={{ p: 2 }} id="sale-intimation-print">
          <Typography variant="subtitle1">Catalogue: {data.catalogueNo} | Auction Date: {formatDate(data.auctionDate)} | Letter Date: {formatDate(data.letterDate)}</Typography>
          <Typography variant="body2" sx={{ mt: 2 }}>Sale intimation – the following pledge(s) have been sold at auction:</Typography>
          <Box component="ul" sx={{ mt: 1 }}>
            {(data.items || []).map((item, i) => (
              <li key={i}>
                <Typography variant="body2">P.T. {item.ticketNo} – {item.customerName} – {item.address || ''}</Typography>
              </li>
            ))}
          </Box>
          <Button variant="outlined" sx={{ mt: 2 }} onClick={() => window.print()}>Print</Button>
        </Paper>
      )}
    </Box>
  );
};

export default SaleIntimationLetterTab;
